import{VERSION as e}from"../../../version.mjs";const o=`ui-react-liveness/${e}`,r=()=>o;export{r as getLivenessUserAgent};
